<template>
  <div>
    <header-card
      :title="$t('reply.edit')"
      show-back
      :route-url="{name:'owner:instagram-reports'}"
    />
    <process-reply
      :edit="true"
      :is-facebook="false"
    />
  </div>
</template>

<script>
import ProcessReply from '@/views/owner-instagram/reply/components/ProcessReply'
import HeaderCard from '@/@bya3/components/cards/HeaderCard'

export default {
  name: 'EditStoryReply',
  components: { HeaderCard, ProcessReply },
}
</script>
